import React from "react";
import "./App.css";
import { Layout, ConfigProvider, Tabs } from "antd";
import { Content } from "antd/es/layout/layout";
import "dayjs/locale/nl";
import locale from "antd/locale/nl_NL";
import TravelExpensesForm from "./TravelExpensesForm";
import WorkFromHomeForm from "./WorkFromHomeForm";

const App = () => {
    const items = [
        {
            key: "1",
            label: "Reiskosten",
            children: <TravelExpensesForm />,
        },
        {
            key: "2",
            label: "Thuiswerkdagen",
            children: <WorkFromHomeForm />,
        },
    ];

    return (
        <ConfigProvider locale={locale}>
            <Layout style={{ height: "100vh" }}>
                <Content style={{ padding: 24 }}>
                    <Tabs defaultActiveKey="1" items={items} />
                </Content>
            </Layout>
        </ConfigProvider>
    );
};

export default App;
